require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./malheur-county-jail-diversion.json") })
        }
      }, "path---malheur-county-jail-diversion");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---malheur-county-jail-diversion!./.cache/json/malheur-county-jail-diversion.json
// module id = 928
// module chunks = 231608221292675